<template>
    <div class="text" @click.self="work">
        {{data}}
    </div>
</template>

<script>
    export default {
        name: "PopupContents",
        props: {
            data: String,
            confirmEvent: Boolean,
        },
        data() {
            return {
                returnData: "this is return data",
            }
        },
        watch: {
            confirmEvent() {
                this.$emit("input", false);
                this.result(1);
            }

        },
        methods: {
            // 向父页面返回结果
            result(value) {
                this.returnData = value;
                this.$emit("ok", this.returnData);
            },
            work() {
                this.$emit("ok", this.returnData);
            }
        }
    }
</script>

<style scoped>
    .text {
        min-width: 400px;
        margin-top: 50px;
        min-height: 50px;
    }

</style>